// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"949c7746","394":"54343f1d","812":"f279bc1a"}[chunkId] + ".chunk.js";
};